/**
 * Tipos internos da tela de Documentos.
 *
 * Papel: aqui ficam `DocumentoNoFormulario`, o formato que o react-hook-form
 * guarda enquanto a pessoa preenche, e o valor em branco de onde a criação
 * parte.
 *
 * `DocumentoNoFormulario` é derivado de `novoDocumentoSchema` com `z.input`, e
 * não escrito à mão, porque é a entrada daquele schema que o formulário precisa
 * produzir. Um tipo próprio compilaria e passaria a divergir no dia em que um
 * campo mudasse de forma no contrato — e a divergência apareceria como erro de
 * gravação, não de compilação.
 */
import { type novoDocumentoSchema } from '@concierge/shared';
import { type z } from 'zod';

/** O documento como o formulário o guarda, antes de o schema normalizar. */
export type DocumentoNoFormulario = z.input<typeof novoDocumentoSchema>;

/**
 * Um documento em branco, como o formulário de criação começa.
 *
 * As datas entram como string vazia, e não ausentes: o `CampoMascarado` é
 * controlado, e com `undefined` o React reclamaria da troca de não controlado
 * para controlado na primeira tecla. O schema converte o vazio em `null` no
 * envio.
 *
 * `pessoaId` e `tipo` começam vazios de propósito, e o formulário não salva
 * enquanto os dois não forem preenchidos: um padrão em `pessoaId` faria o
 * documento nascer atribuído à primeira pessoa da lista sempre que alguém
 * salvasse sem olhar. `status` não tem esse recurso, porque o enum não tem
 * valor vazio — começa em `valido`, o caso mais comum.
 */
export const DOCUMENTO_EM_BRANCO: DocumentoNoFormulario = {
  pessoaId: '',
  tipo: '',
  numero: '',
  emissao: '',
  validade: '',
  status: 'valido',
  observacao: '',
};
